import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

import openLockIcon from '@assets/images/icons/open-lock.png'

import './ResultPageFooter.scss'

export const ResultPageFooterExternalApp: FunctionComponent = () => {
  const { t } = useTranslation('Result')

  return (
    <div className="ResultPageFooter">
      <div className="ResultPageFooter-container">
        <div className="ResultPageFooter-container-img">
          <img src={openLockIcon} />
        </div>
        <div className="ResultPageFooter-container-text">{t('questionTextSimulatorExternal')}</div>
      </div>
    </div>
  )
}
